import React from 'react'
import { useForm } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

import { INPUT_TYPES, InputTypeText } from '../../../../../../forms'
import { Modal } from '../../../../../../molecules'

interface IUserAskedQuotationModal {
  phoneNumber: string
  isOpen: boolean
  onSubmit: (args: { phoneNumber: string }) => void
  closeModal: () => void
  isLoading: boolean
}

const UserCanAskQuotationModal = ({
  isOpen,
  closeModal,
  phoneNumber,
  onSubmit,
  isLoading,
}: IUserAskedQuotationModal) => {
  const intl = useIntl()
  const {
    control,
    formState: { isValid },
    getValues,
  } = useForm<{
    phoneNumber: string
  }>({
    mode: 'onBlur',
    defaultValues: {
      phoneNumber: phoneNumber || '',
    },
  })

  return (
    <Modal
      closeModal={closeModal}
      isOpen={isOpen}
      title={intl.formatMessage({
        id: 'ui.ModalAskQuotation.title',
        defaultMessage: 'Confirmer la demande de devis',
      })}
      footer={{
        button: {
          label: intl.formatMessage({
            id: 'ui.ModalAskQuotation.confirm',
            defaultMessage: 'Confirmer',
          }),
          onClick: () => onSubmit({ phoneNumber: getValues('phoneNumber') }),
          disabled: !isValid,
          isLoading,
        },
      }}
    >
      <p>
        <FormattedMessage
          id='ui.ModalAskQuotation.confirmQuoteQuestion'
          defaultMessage='Confirmez-vous l’envoi d’une demande de devis à l’hôte ?'
        />
      </p>
      <br />
      <p>
        <FormattedMessage
          id='ui.ModalAskQuotation.contentInformation'
          defaultMessage='Celui-ci sera notifié immédiatement afin de confirmer la disponibilité et les prix de l’établissement aux dates demandées.'
        />
      </p>
      <br />
      <p className='mt-6'>
        <FormattedMessage
          id='ui.ModalAskQuotation.confirmPhoneNumber'
          defaultMessage='Confirmez votre numéro de téléphone'
        />
        <span className='text-red-500'>*</span>
      </p>
      <InputTypeText
        inputType={INPUT_TYPES.PHONE}
        rules={{
          required: true,
        }}
        placeholder='+33'
        control={control}
        name='phoneNumber'
        value={getValues('phoneNumber')}
      />
    </Modal>
  )
}

export default UserCanAskQuotationModal
